import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Menu from "./components/Menu";
import SEO from "./components/SEO";
import Introducing from "./sections/Introducing";
import Footer from "./sections/Footer";
import ConvertPage from "./pages/convertPage";
import TermsOfService from "./pages/TermsOfService";
import Roadmap from "./sections/Roadmap";
import Ibird from "./sections/Ibird";
import HowWorks from "./sections/HowWorks";
// import Analytics from "./sections/Analytics";
import "./index.css";

function App() {
  return (
    <Router>
      <div className="font-roboto">
        <Menu />
        <Routes>
          <Route
            path="/"
            element={
              <>
                <SEO
                  title="iAssets | Building iBird - Decentralized Social Media on Hedera"
                  description="iAssets is building iBird, a revolutionary decentralized social media platform on Hedera Hashgraph. Experience Web3 social networking with HBAR, ASSET tokens, and true digital freedom."
                  keywords="iAssets, iBird, Hedera, HBAR, ASSET, Web3, Decentralized Social Media, Blockchain, Cryptocurrency, DeFi, SocialFi, Hedera Hashgraph, HCS, HTS, Token Burning, Cross-chain"
                  url="/"
                  canonical="https://iassets.org/"
                />
                <Introducing />
                {/* <Analytics /> */}
                <Ibird />
                <HowWorks />
                <Roadmap />
                <Footer />
              </>
            }
          />
          <Route
            path="/convert"
            element={
              <>
                <SEO
                  title="Convert Tokens | iAssets - BSC to Hedera Token Bridge"
                  description="Convert your NBM and ASSET tokens from Ethereum to Hedera network. Secure, fast, and decentralized token burning and minting process powered by iAssets."
                  keywords="Token Conversion, Ethereum to Hedera, NBM Token, ASSET Token, Token Burning, Cross-chain Bridge, iAssets Convert"
                  url="/convert"
                  canonical="https://iassets.org/convert"
                />
                <ConvertPage />
              </>
            }
          />
          <Route
            path="/TermsOfService"
            element={
              <>
                <SEO
                  title="Terms of Service | iAssets"
                  description="Read the Terms of Service for iAssets platform and iBird social media application. Understand your rights and responsibilities when using our decentralized services."
                  keywords="Terms of Service, Legal, iAssets, iBird, User Agreement, Privacy Policy"
                  url="/TermsOfService"
                  canonical="https://iassets.org/TermsOfService"
                  type="article"
                />
                <TermsOfService />
              </>
            }
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
